import { render } from "./References.vue?vue&type=template&id=212f0e15&scoped=true&ts=true"
import script from "./References.vue?vue&type=script&lang=ts"
export * from "./References.vue?vue&type=script&lang=ts"

import "./References.vue?vue&type=style&index=0&id=212f0e15&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212f0e15"]])

export default __exports__